import { Suspense, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { SubpageLayout } from '../../components/layouts/subpage-layout';
import { NewPagination } from '../../components/new-pagination/new-pagination';
import { SimpleCompanyCardGrid } from '../../components/simple-company-card-grid/simple-company-card-grid';
import { useMostVisitedCompanies } from '../../hooks/use-most-visited-companies';
import { usePagination } from '../../hooks/use-pagination';
import { createSimpleCompanies } from '../../models/simple-company';

const LIMIT = 78;

type LOMostVisitedCompaniesProps = {
  trackingPage: string;
};

const LOMostVisitedCompaniesInner: React.FC<LOMostVisitedCompaniesProps> = ({
  trackingPage,
}) => {
  const { activePage } = usePagination();
  const [totalCompanies, setTotalCompanies] = useState(0);

  const { data } = useMostVisitedCompanies({
    limit: LIMIT,
    offset: LIMIT * (activePage - 1),
  });

  useEffect(() => {
    const total = data?.mostVisitedCompanies?.total ?? 0;

    if (totalCompanies !== total) {
      setTotalCompanies(total);
    }
  }, []);

  const mostVisitedCompanies = data?.mostVisitedCompanies?.collection ?? [];
  // @ts-expect-error ignore null errors from graphql
  const simpleCompanyCards = createSimpleCompanies(mostVisitedCompanies);

  return (
    simpleCompanyCards && (
      <>
        <SimpleCompanyCardGrid
          items={simpleCompanyCards}
          trackingPage={trackingPage}
        />
        <NewPagination
          currentPage={activePage}
          perPage={LIMIT}
          limitPages={4}
          total={totalCompanies}
        />
      </>
    )
  );
};

export const LOMostVisitedCompanies: React.FC<LOMostVisitedCompaniesProps> = ({
  trackingPage,
}) => {
  const intl = useIntl();
  return (
    <SubpageLayout
      headerText={intl.$t({ id: 'CP_100_MOST_CLICKED_COMPANIES_HEADLINE' })}
      description={intl.$t({ id: 'CP_100_MOST_CLICKED_COMPANIES_TEXT' })}
    >
      <Suspense
        fallback={<SimpleCompanyCardGrid.Skeleton amountOfCards={LIMIT} />}
      >
        <LOMostVisitedCompaniesInner trackingPage={trackingPage} />
      </Suspense>
    </SubpageLayout>
  );
};
